module.exports = __webpack_public_path__ + "img/pic_2_tc.d4410868.png";